// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2":"67a70263","722":"67a70263","841":"67a70263","885":"67a70263"}[chunkId] + ".chunk.css";
};